import React from "react";
import { Container, Navbar, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../css/sidebar_admin.css";

function SidebarAdmin() {
  return (
    <Container fluid className=" h-100 m-0 p-0 text_data_admin">
      <div className="box_dashboard h-100">
        <Navbar
          collapseOnSelect
          expand="xl"
          bg=""
          variant="dark"
          className="flex-column rounded-custom-admin navbar_container h-100 sidebar d-flex align-items-center px-4"
        >
          <div className=" w-100 m-0  text-end py-2 ">
            <Navbar.Toggle aria-controls="responsive-navbar-nav" className="" />
          </div>
          <Container fluid className="w-100 m-0 p-0">
            <Navbar.Collapse id="responsive-navbar-nav" className="m-0 p-0">
              <Nav className="flex-column fs-5 w-100 mt-2 text-center text-xl-start">
                <Navbar.Brand
                  as={Link}
                  to={"/"}
                  className="title_data m-0 p-0 section-title text-center"
                >
                  Rosella Clementi
                </Navbar.Brand>
                <div className="border-custom-white"></div>

                <Nav.Link
                  as={Link}
                  to="/admin"
                  className="nav-link-admin my-2 mt-5 "
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-grid-1x2-fill" viewBox="0 0 16 16">
                      <path d="M0 1a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1zm9 0a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1V1zm0 9a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-5z"/>
                  </svg>
                  <span className="ms-2">Dashboard</span>
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/admin/categoryList"
                  className="nav-link-admin my-2"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-bookmark-fill"
                    viewBox="0 0 16 16"
                  >
                    <path d="M2 2v13.5a.5.5 0 0 0 .74.439L8 13.069l5.26 2.87A.5.5 0 0 0 14 15.5V2a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2" />
                  </svg>
                  <span className="ms-2">Categorie</span>
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/admin/newsList"
                  className="nav-link-admin my-2"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-megaphone-fill" viewBox="0 0 16 16">
                      <path d="M13 2.5a1.5 1.5 0 0 1 3 0v11a1.5 1.5 0 0 1-3 0v-11zm-1 .724c-2.067.95-4.539 1.481-7 1.656v6.237a25.222 25.222 0 0 1 1.088.085c2.053.204 4.038.668 5.912 1.56V3.224zm-8 7.841V4.934c-.68.027-1.399.043-2.008.053A2.02 2.02 0 0 0 0 7v2c0 1.106.896 1.996 1.994 2.009a68.14 68.14 0 0 1 .496.008 64 64 0 0 1 1.51.048zm1.39 1.081c.285.021.569.047.85.078l.253 1.69a1 1 0 0 1-.983 1.187h-.548a1 1 0 0 1-.916-.599l-1.314-2.48a65.81 65.81 0 0 1 1.692.064c.327.017.65.037.966.06z"/>
                  </svg>
                  <span className="ms-2">Notizie</span>
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/admin/musicList"
                  className="w-100 nav-link-admin my-2"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-music-note" viewBox="0 0 16 16">
                    <path d="M9 13c0 1.105-1.12 2-2.5 2S4 14.105 4 13s1.12-2 2.5-2 2.5.895 2.5 2"/>
                    <path fill-rule="evenodd" d="M9 3v10H8V3z"/>
                    <path d="M8 2.82a1 1 0 0 1 .804-.98l3-.6A1 1 0 0 1 13 2.22V4L8 5z"/>
                  </svg>
                  <span className="ms-2">Musica</span>
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/admin/activityList"
                  className="w-100 nav-link-admin my-2"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-hourglass-split"
                    viewBox="0 0 16 16"
                  >
                    <path d="M2.5 15a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1zm2-13v1c0 .537.12 1.045.337 1.5h6.326c.216-.455.337-.963.337-1.5V2zm3 6.35c0 .701-.478 1.236-1.011 1.492A3.5 3.5 0 0 0 4.5 13s.866-1.299 3-1.48zm1 0v3.17c2.134.181 3 1.48 3 1.48a3.5 3.5 0 0 0-1.989-3.158C8.978 9.586 8.5 9.052 8.5 8.351z" />
                  </svg>
                  <span className="ms-2">Attività</span>
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>
    </Container>
  );
}

export default SidebarAdmin;
